import {useState, useEffect} from 'react';
import {DEFAULT_CITY} from 'ultra/const/general';
import {getClientCity} from 'ultra/configs/general';
import {getClientCityTimezone} from 'ultra/configs/general';
import {getTime} from 'ultra/helpers/date'

import {useConfigStore} from '../../../Stores/config';

import './index.scss';

export default function WorkSchedule(props) {
    const {workingHours} = props;

    const [timeZone, setTimeZone] = useState()
    const [closed, setClosed] = useState(false)

    const {configs} = useConfigStore();

    useEffect(() => {
        const city = getClientCity(window) || DEFAULT_CITY;
        setTimeZone(getClientCityTimezone(configs, city));

        const now = getTime(new Date(), timeZone);

        const d = now.locale('uk').day();
        const h = now.locale('uk').hour();
        const m = now.locale('uk').minute();

        let interval
        if (d == 6) {
            interval = workingHours.st
        }
        else if (d == 7) {
            interval = workingHours.sn
        }
        else {
            if (workingHours.weekdays) {
                interval = workingHours.weekdays
            }
            else {
                if (d === 1) interval = workingHours.mn
                if (d === 2) interval = workingHours.tu
                if (d === 3) interval = workingHours.wd
                if (d === 4) interval = workingHours.th
                if (d === 5) interval = workingHours.fr
            }
        }

        if (
            interval.from && interval.to
            &&
            (
                (h <= Number(interval.from.h) && m <= Number(interval.from.m))
                ||
                (h >= Number(interval.to.h) && m >= Number(interval.to.m))
            )
        ) {
            setClosed(true)
        }
    }, [configs])

    if (!workingHours) return <></>

    if (closed) {
        return <div className="WorkSchedule">
            <div className='closed'>💤 Ви звернулись в неробочий час</div>
            <div className='info'>Ви можете продовжити та оформити заявку, оператор звяжеться з вами <i>наступного робочого дня</i>:</div>
            <div className='schedule'>🗓️ Графік роботи:</div>
            {workingHours?.mn && <DaySchedule label="Понеділок" config={workingHours.mn} />}
            {workingHours?.tu && <DaySchedule label="Вівторок" config={workingHours.tu} />}
            {workingHours?.wd && <DaySchedule label="Середа" config={workingHours.wd} />}
            {workingHours?.th && <DaySchedule label="Четверг" config={workingHours.th} />}
            {workingHours?.fr && <DaySchedule label="П'ятниця" config={workingHours.fr} />}

            {workingHours?.weekdays && <DaySchedule label="З понеділка по пʼятницю" config={workingHours.weekdays} />}

            {workingHours?.st && <DaySchedule label="Субота" config={workingHours.st} />}
            {workingHours?.sn && <DaySchedule label="Неділя" config={workingHours.sn} />}
        </div>
    }

    return <></>
}

function DaySchedule(props) {
    const {label, config} = props;

    return <div className='day labelWrap'>
        <div className='label'>{label}:</div>
        <div className='labelValue'>
            {config.dayoff && <>вихідний</>}
            {config.from && <>{config.from.h}:{config.from.m ? config.from.m : "00"} - </>}
            {config.to && <>{config.to.h}:{config.to.m ? config.to.m : "00"}</>}
        </div>
    </div>
}
